import React, { Suspense, lazy } from 'react'
import { HashRouter as Router, Routes, Route } from 'react-router-dom'
// import HomePage from './pages/HomePage'
import NavbarMain from './components/NavbarMain'
import Footer from './components/Footer'

import ScrollToTop from './components/ScrollToTop'
import Preloader from './components/Preloader'
import HomePage from './pages/HomePage'
import PrivateRoute from './contexts/PrivateRoute'
import LoginPage from './pages/LoginPage'


const EvapotranspirationPage = lazy(() => import('./pages/EvapotranspirationPage'));
// const HomePage = lazy(() => import('./pages/HomePage'));
const PrecipitationPage = lazy(() => import('./pages/PrecipitationPage'));
const BiomassPage = lazy(() => import('./pages/BiomassPage'));
const LandClassificationPage = lazy(() => import('./pages/LandClassificationPage'));
const WaterFootprintPage = lazy(() => import('./pages/WaterFootprintPage'));
const OtherDataPage = lazy(() => import('./pages/OtherDataPage'));
const ClimateChangePage = lazy(() => import('./pages/ClimateChangePage'));
const DataManualPage = lazy(() => import('./pages/DataManualPage'));
const WaterProductivity = lazy(() => import('./pages/WaterProductivity'));
const DroughtConditions = lazy(() => import('./pages/DroughtConditions'));
const VirtualWaterPage = lazy(() => import('./pages/VirtualWaterPage'));
const BenchmarkPage = lazy(() => import('./pages/BenchmarkPage'));
const DataDownloadPage = lazy(() => import('./pages/DataDownloadPage'));



const App = () => {

  return (
    <>


        <Suspense fallback={<Preloader />}>
          <Routes>

    <Route path='/login' element={<LoginPage />} />

            <Route path="/" element={<PrivateRoute />}>
              <Route path='/' element={<HomePage />} />
            </Route>

            <Route path="/et" element={<PrivateRoute />}>
              <Route path='/et' element={<EvapotranspirationPage />} />
            </Route>

            <Route path="/pcp" element={<PrivateRoute />}>
              <Route path='/pcp' element={<PrecipitationPage />} />
            </Route>

            <Route path="/bp" element={<PrivateRoute />}>
              <Route path='/bp' element={<BiomassPage />} />
            </Route>

            <Route path="/benchmark" element={<PrivateRoute />}>
              <Route path='/benchmark' element={<BenchmarkPage />} />
            </Route>

            <Route path="/climate" element={<PrivateRoute />}>
              <Route path='/climate' element={<ClimateChangePage />} />
            </Route>

            <Route path="/lcc" element={<PrivateRoute />}>
              <Route path='/lcc' element={<LandClassificationPage />} />
            </Route>

            <Route path="/wf" element={<PrivateRoute />}>
              <Route path='/wf' element={<WaterFootprintPage />} />
            </Route>

            <Route path="/wp" element={<PrivateRoute />}>
              <Route path='/wp' element={<WaterProductivity />} />
            </Route>

            <Route path="/dc" element={<PrivateRoute />}>
              <Route path='/dc' element={<DroughtConditions />} />
            </Route>

            <Route path="/data-manual" element={<PrivateRoute />}>
              <Route path='/data-manual' element={<DataManualPage />} />
            </Route>

            <Route path="/other-data" element={<PrivateRoute />}>
              <Route path='/other-data' element={<OtherDataPage />} />
            </Route>

            <Route path="/vw" element={<PrivateRoute />}>
              <Route path='/vw' element={<VirtualWaterPage />} />
            </Route>

            <Route path="/download" element={<PrivateRoute />}>
              <Route path='/download' element={<DataDownloadPage />} />
            </Route>





          </Routes>
        </Suspense>
        <ScrollToTop />
        {/* <Footer /> */}


    </>

  )
}

export default App